import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './auth/AuthProvider';
import { AppDrawer } from './components/layout/AppDrawer';
import { AgreementListPage } from './pages/AgreementListPage';
import { AgreementDetailPage } from './pages/AgreementDetailPage';
import { QuarantinePage } from './pages/QuarantinePage';
import { AvsjekkPage } from './pages/AvsjekkPage';
import { AuditPage } from './pages/AuditPage';
import { UploadPage } from './pages/UploadPage';
import { IncomeLinesPage } from './pages/IncomeLinesPage';
import { DimensionsPage } from './pages/DimensionsPage';
import { BudgetImportPage } from './pages/BudgetImportPage';
import { ChatPage } from './pages/ChatPage';
import { lazy } from 'react';
import { InnsiktLayout } from './pages/innsikt/InnsiktLayout';
// Lazy-load tunge ECharts-sider — holdes utenfor hovedbundelen.
const LederDashboard = lazy(() => import('./pages/innsikt/LederDashboard').then((m) => ({ default: m.LederDashboard })));
const Risikolinse = lazy(() => import('./pages/innsikt/Risikolinse').then((m) => ({ default: m.Risikolinse })));
const DekningAvstemming = lazy(() => import('./pages/innsikt/DekningAvstemming').then((m) => ({ default: m.DekningAvstemming })));
const Inntektsflyt = lazy(() => import('./pages/innsikt/Inntektsflyt').then((m) => ({ default: m.Inntektsflyt })));

export function App() {
  return (
    <AuthProvider>
      <Routes>
        <Route element={<AppDrawer />}>
          <Route path="/" element={<Navigate to="/agreements" replace />} />
          <Route path="/agreements" element={<AgreementListPage />} />
          <Route path="/agreements/:id" element={<AgreementDetailPage />} />
          <Route path="/income-lines" element={<IncomeLinesPage />} />
          <Route path="/dimensions" element={<DimensionsPage />} />
          <Route path="/quarantine" element={<QuarantinePage />} />
          <Route path="/avsjekk" element={<AvsjekkPage />} />
          <Route path="/upload" element={<UploadPage />} />
          <Route path="/budget-import" element={<BudgetImportPage />} />
          <Route path="/audit" element={<AuditPage />} />
          <Route path="/chat" element={<ChatPage />} />
          <Route path="/innsikt" element={<InnsiktLayout />}>
            <Route index element={<Navigate to="/innsikt/leder" replace />} />
            <Route path="leder" element={<LederDashboard />} />
            <Route path="risiko" element={<Risikolinse />} />
            <Route path="dekning" element={<DekningAvstemming />} />
            <Route path="flyt" element={<Inntektsflyt />} />
          </Route>
        </Route>
      </Routes>
    </AuthProvider>
  );
}
